import { http } from '../../services/http';
import { reactLocalStorage } from 'reactjs-localstorage';

export const getToken = (force = false) => {
  return dispatch => {
    if (reactLocalStorage.get('token', false) && !force) {
      dispatch({ type: 'GET_TOKEN_SUCCESS', data: reactLocalStorage.get('token') });
    } else {
      http
        .post('/configure/save')
        .then(response => {
          reactLocalStorage.set('token', response.data.result.token);
          dispatch({ type: 'GET_TOKEN_SUCCESS', data: response.data.result.token });
        })
        .catch(err => {
          dispatch({ type: 'GET_TOKEN_ERROR', data: err });
        });
    }
  };
};
